/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";import AlertDialog from "../../components/AlertDialog";

export default function AddTenant(props) {
  const { api } = useContext(FirebaseContext);
  const {
    updateProfile,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
  } = api;
  const [state, setState] = useState({
    userType: "tenant",
    firstName: "",
    lastName: "",
    username: "",
    identityNumber: "",
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: "Default",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: "",
    licenseImage: null,
    brokerImage: null,
    landlordImage: null,
    other_info: "",
    password: "",
    email: "",
  });
  const [isdepdata, setIsdepData] = useState({
    isIndependent: false,
  });
  // const specialities = useSelector(
  //   (state) => state.specialitytypes.specialities
  // );
  const [specialityTypes, setSpecialityTypes] = useState({});
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const usersdata = useSelector((state) => state.usersdata);
  const dispatch = useDispatch();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const columns = [
    { title: language.first_name, field: "firstName", initialEditValue: "" },
    { title: language.last_name, field: "lastName", initialEditValue: "" },
    { title: "Identity Number", field: "identityNumber", initialEditValue: "" },

    {
      title: language.email,
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
    },
    { title: "password", field: "password", initialEditValue: "" },
    {
      title: language.mobile,
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
    },

    {
      title: language.account_approve,
      field: "practiceAdminActiveStatus",
      type: "boolean",
      initialEditValue: true,
    },
  ];
   useEffect(() => {
     if (usersdata.users) {
       setData(
         usersdata.users.filter(
           (user) => user.userType === "tenant"
           // user.practiceNumber === auth.info.profile.practiceNumber
         )
       );
     } else {
       setData(usersdata.users);
     }
   }, [usersdata.users]);
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  return(
  <MaterialTable
    title={"Tenants"}
    columns={columns}
    data={data}
    options={{
      exportButton: true,
      sorting: true,
      actionsColumnIndex: -1,
    }}
    editable={{
      onRowAdd: (newData) =>
        new Promise((resolve, reject) => {
          setTimeout(() => {
            checkUserExists(newData).then((res) => {
              if (res.users && res.users.length > 0) {
                alert(language.user_exists);
                reject();
              } else if (res.error) {
                alert(language.email_or_mobile_issue);
                reject();
              } else {
                newData["createdByAdmin"] = true;

                newData["userType"] = "tenant";
                newData["createdAt"] = new Date().toISOString();
                newData["referralId"] =
                  newData.firstName.toLowerCase() +
                  Math.floor(1000 + Math.random() * 9000).toString();
                setState({
                  ...state,
                  newData,
                });
                newData["username"] =
                  newData.firstName.toLowerCase() +
                  newData.lastName.toLowerCase() +
                  Math.floor(1000 + Math.random() * 9000).toString();
                setState({
                  ...state,
                  newData,
                });
                let role = auth.info.profile.userType;
                if (role === "tenant") {
                  newData["tenant"] = auth.info.uid;
                }
                dispatch(
                  updateProfile(auth.info, {
                    isIndependent: false,
                    privatePractice: true,
                  })
                );
                emailSignUp(newData).then((res) => {
                  resolve();
                  console.log("i am the back data", res);
                  if (res.uid) {
                    setTimeout(() => {
                      setCommonAlert({
                        open: true,
                        msg: language.account_create_successfully,
                      });
                      props.history.push("/login");
                      console.log(newData);
                    }, 3000);
                  } else {
                    setCommonAlert({
                      open: true,
                      msg: language.reg_error,
                    });
                  }
                });
              }
            });
          }, 600);
        }),

      onRowUpdate: (newData, oldData) =>
        new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            dispatch(editUser(oldData.id, newData));
          }, 600);
        }),
      onRowDelete: (oldData) =>
        features.AllowCriticalEditsAdmin
          ? new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                dispatch(deleteUser(oldData.id));
              }, 600);
            })
          : new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                alert(language.demo_mode);
              }, 600);
            }),
   }}
  />);
}
